<template>
  <div class="promo-footer">
    <div class="promo-footer__content">
      <p
        v-if="coverAuthor"
        class="promo-footer__content-cover-text"
      >
        Обложка:&nbsp;
        <a
          target="_blank"
          :href="article.meta.cover_source_url"
          >{{ coverAuthor }}</a
        >
      </p>
      <span class="promo-footer__content-advertising-link"
        >Реклама:&nbsp;
        <a
          target="_blank"
          :href="article.meta.ads_source_url"
          >{{ advertText }}</a
        >
      </span>
      <p class="promo-footer__content-error-text">
        Если нашли ошибку, выделите текст и нажмите Ctrl + Enter
      </p>
    </div>
    <div
      class="share"
      @mouseenter="handleMouseEnter"
      @mouseleave="sharingHover = false"
    >
      <BaseButton
        class="share__btn"
        @click.stop="toggleSharing"
      >
        <SvgAsset
          class="share__btn-icon"
          :content="sharePath"
        />
      </BaseButton>
      <SharingDesktop
        class="share__social-sharing"
        :class="sharingMenuClass"
        :article="article"
        :shown="sharingHover"
      />
    </div>
  </div>
</template>

<script lang="ts">
  import SharingDesktop from '~/components/Sharing/SharingDesktop.vue';
  import SharingMobile from '~/components/Sharing/SharingMobile.vue';
  import BaseButton from '~/components/BaseComponents/BaseButton.vue';
  import { isTouchDevice } from '~/utils';
  import { useModal } from '@devhacker/shared/plugins/modal/useModal';
  import { useSingleArticleStore } from '~/store/singleArticle';
  import SvgAsset from '@devhacker/shared/components/SvgAsset.vue';
  import sharePath from '@/assets/images/svg/share.svg?raw';

  export default defineNuxtComponent({
    name: 'PromoArticleFooter',
    components: {
      SvgAsset,
      SharingDesktop,
      BaseButton,
    },

    inject: {
      // Контекст события для аналитики
      // Где находится элемент с которым происходит событие
      eventItemSharingList: {
        default: '',
      },
    },

    data() {
      return {
        sharingHover: false,
      };
    },

    computed: {
      sharePath: () => sharePath,
      article() {
        return useSingleArticleStore().article;
      },

      advertText(): string {
        return this.article.meta.ads_source;
      },

      coverAuthor(): string {
        return this.article.meta.cover_source;
      },

      sharingMenuClass(): Record<string, boolean> {
        return {
          'share__social-sharing--shown': this.sharingHover,
        };
      },
    },

    methods: {
      handleMouseEnter() {
        this.sharingHover = !isTouchDevice();
      },

      toggleSharing() {
        if (!isTouchDevice()) return;

        if (navigator.share !== undefined) {
          this.sendWebShareEvent('Открытие меню');
          navigator
            .share({
              url: this.article.url,
              title: this.article.title,
            })
            .then(() => this.sendWebShareEvent('Переход в приложение'))
            .catch(() => this.sendWebShareEvent('Закрытие меню'));
        } else {
          useModal().open(
            SharingMobile,
            {
              closeClickOutside: true,
              article: this.article,
            },
            {
              transition: 'modal-fade',
            },
          );
        }
      },

      // Функция для аналитики "поделиться"
      sendWebShareEvent(_action: string) {},
    },
  });
</script>

<style lang="scss" scoped>
  .promo-footer {
    width: 100%;
    font-family: $text-font--1;
    font-weight: 400;
    line-height: 18px;
    font-size: 12px;
    margin: 0 auto;
    &__content {
      color: $text-color--1;
      text-align: center;
      :nth-child(n + 2) {
        display: block;
        margin-top: $spacing-2;
      }
      &-error-text {
        display: none;
        @include big-tablet {
          display: block;
        }
      }
    }
  }
  .share {
    width: 48px;
    height: 32px;
    border-radius: 40px;
    background: #f5f5f4;
    margin: $spacing-4 auto 0;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    &__social-sharing {
      position: absolute;
      visibility: hidden;
      transition: all 0.1s ease-in 0.3s;
      left: 0;
      bottom: 0;
      transform: translateY(-35px);
      z-index: 9999999999;
      opacity: 0;
      display: none;

      @include tablet {
        display: block;
      }

      &--shown {
        opacity: 1;
        visibility: visible;
        transition-delay: 0s;
        pointer-events: all;
      }
    }
    @include hover {
      cursor: pointer;
      background: #e8e8e8;
    }
    &__btn {
      &-icon {
        :deep() {
          svg path {
            fill: #4c4c4c;
          }
        }
        min-width: 24px;
        min-height: 24px;
      }
    }
  }
</style>
